import {
  Companion_getInstance2xymkrjuj4ub8 as Companion_getInstance,
  Codes_CLOSED_ABNORMALLY_getInstance2rjj5xk3ewrku as Codes_CLOSED_ABNORMALLY_getInstance,
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance1akc4vzdzyb59 as Codes_NORMAL_getInstance,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/CloseReason.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  Key_instance2rlngjw9v1qsd as Key_instance,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { decodeToString1dbzcjd620q25 as decodeToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { writeFully359t6q8kam2g5 as writeFully } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import { readText3frapgncbqrcg as readText } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/Deprecation.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import { Factory_getInstance3boxsed5qz5iy as Factory_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { from3gpkuvfyl3bft as from } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketChannelsConfig.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  Text3e6ukp9joohql as Text,
  Binary3tlzyfojm51s4 as Binary,
  Close3tx65evcwi73t as Close,
} from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/Frame.web.mjs';
import { WebSocketExceptionb5mwyitzck0i as WebSocketException } from './WebSockets.mjs';
import { asStringm4998zsa7g15 as asString } from '../../utils/JsUtils.js.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { send3kjrrxgwu0vpw as send } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function isReservedStatusCode($this, $receiver) {
  // Inline function 'kotlin.let' call
  var resolved = Companion_getInstance().d5f($receiver);
  return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
}
var sam$kotlinx_coroutines_DisposableHandle$0Class;
function sam$kotlinx_coroutines_DisposableHandle$0() {
  if (sam$kotlinx_coroutines_DisposableHandle$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.t65_1 = function_0;
      }
      xz() {
        return this.t65_1();
      }
      i5() {
        return this.t65_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, DisposableHandle()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle(), FunctionAdapter()]);
    sam$kotlinx_coroutines_DisposableHandle$0Class = $;
  }
  return sam$kotlinx_coroutines_DisposableHandle$0Class;
}
var JsWebSocketSession$slambdaClass;
function JsWebSocketSession$slambda() {
  if (JsWebSocketSession$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.u65_1 = this$0;
      }
      *k1g($this$launch, $completion) {
        // Inline function 'kotlinx.coroutines.channels.consumeEach' call
        var tmp0 = this.u65_1.z65_1;
        $l$block: {
          // Inline function 'kotlinx.coroutines.channels.consume' call
          var cause = null;
          try {
            var _iterator__ex2g4s = tmp0.p1();
            while (yield* _iterator__ex2g4s.s1a($completion)) {
              var e = _iterator__ex2g4s.r1();
              switch (e.q5g_1.w1_1) {
                case 0:
                  var text = e.r5g_1;
                  this.u65_1.w65_1.send(decodeToString(text, 0, 0 + text.length | 0));
                  break;
                case 1:
                  var tmp = e.r5g_1;
                  var source = tmp instanceof Int8Array ? tmp : THROW_CCE();
                  var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
                  this.u65_1.w65_1.send(frameData);
                  break;
                case 2:
                  // Inline function 'io.ktor.utils.io.core.buildPacket' call

                  var builder = new (Buffer())();
                  writeFully(builder, e.r5g_1);
                  var data = builder;
                  var code = data.u4j();
                  var reason = readText(data);
                  this.u65_1.x65_1.w12(CloseReason().g5f(code, reason));
                  if (isReservedStatusCode(this.u65_1, code)) {
                    this.u65_1.w65_1.close();
                  } else {
                    this.u65_1.w65_1.close(code, reason);
                  }

                  break;
                case 3:
                case 4:
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
            }
            break $l$block;
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              cause = e_0;
              throw e_0;
            } else {
              throw $p;
            }
          }
          finally {
            cancelConsumed(tmp0, cause);
          }
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    JsWebSocketSession$slambdaClass = $;
  }
  return JsWebSocketSession$slambdaClass;
}
function JsWebSocketSession$slambda_0(this$0) {
  var i = new (JsWebSocketSession$slambda())(this$0);
  var l = ($this$launch, $completion) => i.k1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var JsWebSocketSessionClass;
function JsWebSocketSession() {
  if (JsWebSocketSessionClass === VOID) {
    class $ {
      constructor(coroutineContext, websocket, channelsConfig) {
        this.v65_1 = coroutineContext;
        this.w65_1 = websocket;
        this.x65_1 = CompletableDeferred();
        this.y65_1 = from(Factory_getInstance(), channelsConfig.r5f_1);
        this.z65_1 = from(Factory_getInstance(), channelsConfig.s5f_1);
        this.a66_1 = this.y65_1;
        this.b66_1 = this.z65_1;
        this.c66_1 = this.x65_1;
        // Inline function 'io.ktor.client.utils.addEventListener' call
        var this_0 = this.w65_1;
        var event = 'message';
        var callback = (event) => {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var data = event.data;
          var tmp;
          if (data instanceof ArrayBuffer) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$5 = new Int8Array(data);
            tmp = Binary().x5j(true, tmp$ret$5);
          } else {
            if (!(data == null) ? typeof data === 'string' : false) {
              tmp = Text().h5k(data);
            } else {
              var error = IllegalStateException().o('Unknown frame type: ' + event.type);
              this.x65_1.x12(error);
              throw error;
            }
          }
          var frame = tmp;
          this.y65_1.h1b(frame);
          return Unit_instance;
        };
        // Inline function 'org.w3c.dom.AddEventListenerOptions' call
        var o = {};
        o['passive'] = false;
        o['once'] = false;
        o['capture'] = false;
        var options = (!(o == null) ? !(o == null) : false) ? o : THROW_CCE();
        this_0.addEventListener(event, callback, options);
        var tmp = () => {
          this_0.removeEventListener(event, callback);
          return Unit_instance;
        };
        var onMessage = new (sam$kotlinx_coroutines_DisposableHandle$0())(tmp);
        // Inline function 'io.ktor.client.utils.addEventListener' call
        var this_1 = this.w65_1;
        var event_0 = 'error';
        var callback_0 = (event) => {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var cause = WebSocketException().v61(asString(event));
          this.x65_1.x12(cause);
          this.y65_1.q1b(cause);
          this.z65_1.u1b();
          return Unit_instance;
        };
        // Inline function 'org.w3c.dom.AddEventListenerOptions' call
        var o_0 = {};
        o_0['passive'] = false;
        o_0['once'] = false;
        o_0['capture'] = false;
        var options_0 = (!(o_0 == null) ? !(o_0 == null) : false) ? o_0 : THROW_CCE();
        this_1.addEventListener(event_0, callback_0, options_0);
        var tmp_0 = () => {
          this_1.removeEventListener(event_0, callback_0);
          return Unit_instance;
        };
        var onError = new (sam$kotlinx_coroutines_DisposableHandle$0())(tmp_0);
        // Inline function 'io.ktor.client.utils.addEventListener' call
        var this_2 = this.w65_1;
        var event_1 = 'close';
        var callback_1 = (event) => {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var reason = CloseReason().g5f(event.code, event.reason);
          this.x65_1.w12(reason);
          this.y65_1.h1b(Close().n5g(reason));
          this.y65_1.s1b();
          this.z65_1.u1b();
          return Unit_instance;
        };
        // Inline function 'org.w3c.dom.AddEventListenerOptions' call
        var o_1 = {};
        o_1['passive'] = false;
        o_1['once'] = true;
        o_1['capture'] = false;
        var options_1 = (!(o_1 == null) ? !(o_1 == null) : false) ? o_1 : THROW_CCE();
        this_2.addEventListener(event_1, callback_1, options_1);
        var tmp_1 = () => {
          this_2.removeEventListener(event_1, callback_1);
          return Unit_instance;
        };
        new (sam$kotlinx_coroutines_DisposableHandle$0())(tmp_1);
        var tmp0_safe_receiver = this.v65_1.bd(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.jx((cause) => {
            $l$block: {
              // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.runWhenOpen' call
              if (this.w65_1.readyState === WebSocket.OPEN) {
                if (cause == null) {
                  this.w65_1.close();
                } else {
                  this.w65_1.close(Codes_NORMAL_getInstance().a5f_1, 'Client failed');
                }
                break $l$block;
              }
              // Inline function 'io.ktor.client.utils.addEventListener' call
              var this_0 = this.w65_1;
              var event = 'open';
              var callback = (event) => {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                if (cause == null) {
                  this.w65_1.close();
                } else {
                  this.w65_1.close(Codes_NORMAL_getInstance().a5f_1, 'Client failed');
                }
                return Unit_instance;
              };
              // Inline function 'org.w3c.dom.AddEventListenerOptions' call
              var o = {};
              o['passive'] = false;
              o['once'] = true;
              o['capture'] = false;
              var options = (!(o == null) ? !(o == null) : false) ? o : THROW_CCE();
              this_0.addEventListener(event, callback, options);
              var tmp = () => {
                this_0.removeEventListener(event, callback);
                return Unit_instance;
              };
              new (sam$kotlinx_coroutines_DisposableHandle$0())(tmp);
            }
            onMessage.xz();
            onError.xz();
            return Unit_instance;
          });
        }
        // Inline function 'org.w3c.dom.ARRAYBUFFER' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$29 = 'arraybuffer';
        this.w65_1.binaryType = tmp$ret$29;
        launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this));
        // Inline function 'kotlin.require' call
        if (!!channelsConfig.r5f_1.y5i()) {
          var message = 'Suspendable channels are not supported in JS.';
          throw IllegalArgumentException().n2(toString(message));
        }
      }
      gw() {
        return this.v65_1;
      }
      n5f() {
        return this.a66_1;
      }
      o5f() {
        return this.b66_1;
      }
      j5f() {
        return this.c66_1;
      }
      l5f(_) {
        throw WebSocketException().v61('Max frame size switch is not supported in Js engine.');
      }
      m5f() {
        return 9223372036854775807n;
      }
      k5f(negotiatedExtensions) {
        // Inline function 'kotlin.require' call
        if (!negotiatedExtensions.n1()) {
          var message = 'Extensions are not supported.';
          throw IllegalArgumentException().n2(toString(message));
        }
      }
      *c4o($completion) {
        return Unit_instance;
      }
    }
    protoOf($).p5f = send;
    initMetadataForClass($, 'JsWebSocketSession', VOID, VOID, [DefaultWebSocketSession()], [0, 1]);
    JsWebSocketSessionClass = $;
  }
  return JsWebSocketSessionClass;
}
//region block: exports
export {
  JsWebSocketSession as JsWebSocketSession2h93x4rgbt7zw,
};
//endregion

//# sourceMappingURL=JsWebSocketSession.mjs.map
